<template>
<div @click="$emit('click')"
     :class="`odr-text odr-text_color-${color}
        ${italic === 'true' ? 'odr-text_italic' : ''}
        ${bold === 'true' ? 'odr-text_bold' : ''}
        ${large === 'true' ? 'odr-text_large' : ''}
        ${minor === 'true' ? 'odr-text_minor' : ''}
        ${medium === 'true' ? 'odr-text_medium' : ''}
        ${link === 'true' ? 'odr-text_link' : ''}
        ${center === 'true' ? 'odr-text_center' : ''}`">
    <slot></slot>
</div>
</template>
<script>
import { coloringMixin } from '../mixins/coloring'
import '../styles/text.scss'

export default {
    mixins: [coloringMixin],
    props: {
        italic: {
            type: String,
            _descr: 'Make text italic',
        },
        bold: {
            type: String,
            _descr: 'Make text bold',
        },
        link: {
            type: String,
            _descr: 'Make text to be link',
        },
        minor: {
            type: String,
            _descr: 'Make text to be minor',
        },
        medium: {
            type: String,
            _descr: 'Make text to be medium',
        },
        large: {
            type: String,
            _descr: 'Make text to be large',
        },
        center: {
            type: String,
            _descr: 'Align text to center',
        },
    },
}
</script>
